import type { GlobalCollectionId } from '#layers/data-model';

// TODO generate these out in the engine
export const ProjectCollectionIds = {
	MonospaceFile: '19eb534d-129a-4525-abf6-1d894a442a5c' as GlobalCollectionId,
} as const;
